export const RECONCILIATION_COLUMN_NAME = 'nomenclature_name';
export const RECONCILIATION_COLUMN_MAKER = 'maker_name';
export const RECONCILIATION_COLUMN_COUNT = 'count';
export const RECONCILIATION_COLUMN_PRICE = 'price_with_vat';
export const RECONCILIATION_COLUMN_EXPIRE_DATE = 'expire_date';
export const RECONCILIATION_COLUMN_IKPU_CODE = 'ikpucode';
export const RECONCILIATION_COLUMN_NAME_AND_MAKER = 'nomenclature_and_maker_names';

export const RECONCILIATION_REQUIRED_FIELDS = [
  RECONCILIATION_COLUMN_NAME,
  RECONCILIATION_COLUMN_MAKER,
  RECONCILIATION_COLUMN_COUNT,
  RECONCILIATION_COLUMN_PRICE,
] as const;

export const RECONCILIATION_ALL_FIELDS = [
  RECONCILIATION_COLUMN_IKPU_CODE,
  RECONCILIATION_COLUMN_NAME,
  RECONCILIATION_COLUMN_MAKER,
  RECONCILIATION_COLUMN_NAME_AND_MAKER,
  RECONCILIATION_COLUMN_COUNT,
  RECONCILIATION_COLUMN_PRICE,
  RECONCILIATION_COLUMN_EXPIRE_DATE,
] as const;
